import { InfoCard } from '@backstage/core-components';
import { Button, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import BuildIcon from '@material-ui/icons/Build';

const TEMPLATES = [
  {
    id: 'create-microservice',
    title: 'Java Golden Path',
    description: 'Scaffold a new Java microservice with CI/CD, ArgoCD, and Humanitec wiring',
    href: '/create/templates/default/create-microservice',
    Icon: FlashOnIcon,
  },
  {
    id: 'modernize-legacy-app-demo',
    title: 'Modernize Legacy App',
    description: 'AI-driven modernization workflow for existing Java/Spring apps',
    href: '/create/templates/default/modernize-legacy-app-demo',
    Icon: BuildIcon,
  },
];

const useStyles = makeStyles(theme => ({
  templateCard: {
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    height: '100%',
  },
  icon: {
    color: theme.palette.primary.main,
    fontSize: '1.5rem',
  },
  title: {
    fontWeight: 600,
    fontSize: '0.95rem',
  },
  description: {
    fontSize: '0.78rem',
    color: theme.palette.text.secondary,
    flex: 1,
  },
  button: {
    marginTop: theme.spacing(1),
    alignSelf: 'flex-start',
  },
}));

export const QuickLaunchCard = () => {
  const classes = useStyles();
  return (
    <InfoCard title="Quick Launch" subheader="Jump straight into a guided workflow">
      <Grid container spacing={2}>
        {TEMPLATES.map(({ id, title, description, href, Icon }) => (
          <Grid item xs={12} key={id}>
            <div className={classes.templateCard}>
              <Icon className={classes.icon} />
              <Typography className={classes.title}>{title}</Typography>
              <Typography className={classes.description}>{description}</Typography>
              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                size="small"
                href={href}
              >
                Launch
              </Button>
            </div>
          </Grid>
        ))}
      </Grid>
    </InfoCard>
  );
};
